export function Logo({ size = 28, showText = true, className = "", light = false }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <img src="/contaha-icon.png" alt="CONTAHA" style={{ width: size, height: size }} className="object-contain shrink-0" />
      {showText && (
        <span className={`text-[17px] font-extrabold tracking-tight ${light ? "text-white" : "text-[#101516] dark:text-white"}`}>CONTAHA</span>
      )}
    </div>
  );
}

export function LogoPlaceholder({ label = "CLINIC LOGO", className = "" }) {
  return (
    <div
      className={`flex flex-col items-center justify-center rounded-xl border border-dashed border-[#223139]/30 dark:border-[#223139] bg-[#F4FBF7] dark:bg-[#0E1A21] px-4 py-3 ${className}`}
    >
      <div className="h-7 w-7 rounded-lg bg-[#00A85A]/15 flex items-center justify-center mb-1.5">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path d="M4 16l5-5 4 4 3-3 4 4" stroke="#00A85A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="8" cy="8" r="1.8" fill="#00A85A" />
        </svg>
      </div>
      <span className="text-[10px] font-bold uppercase tracking-wider text-[#8B9698]">{label}</span>
    </div>
  );
}
